import React, { useState, useEffect } from "react";
import { TableContainer } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import {
  Table,
  TableBody,
  TableRow,
  TableRowData,
  TableHead,
  TableHeader,
} from "../styledComponents/tableStyle";
import GConfirmDialog from "../gComponents/gConfirmDialog";
import GPagination from "../gComponents/gPagination";
import earnPoints from "../assets/images/point-earn.png";
import withdrawPoints from "../assets/images/point-not-earn.png";
import GButton from "../gComponents/gButton";
import WalletForm from "../forms/walletPointForm";
import useDataFctory from "../useDataFactory";
import Modal from "react-modal";

const columns = [
  { id: "earn", label: "" },
  { id: "points", label: "Points", minWidth: 60, align: "" },
  { id: "text", label: "Text", minWidth: 130, align: "center" },
  { id: "date", label: "Date", minWidth: 80, align: "center" },
];

export default function WalletPoints(props) {
  const [initialLoading, setInitialLoading] = useState(true);
  const { title, value } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedWalletId, setSelectedWalletId] = useState("");
  const [currentPage, setCurrentPage] = useState("");
  const [walletvisible, setWalletvisible] = useState(false);
  let obj = {};
  obj[title] = value;
  obj["page"] = currentPage;
  const {
    loading,
    data: walletData,
    pagination: walletPaginationData,
    Placeholder,
    refreshData,
    TableShimmer,
  } = useDataFctory(props.type + "/wallet", true, obj);

  useEffect(() => {
    console.log(props);
    if (props.type) {
      if (props.onChange) {
        props.onChange("wallet");
      }
    }
    setSelectedWalletId(props.value);
    if (initialLoading == false && props.value) {
      obj[title] = value;
      obj["page"] = currentPage;
      refreshData(obj);
    }
    setInitialLoading(false);
  }, [currentPage, selectedWalletId]);

  const handleChangePage = (pageUrl) => {
    console.log(pageUrl);
    var NewPageNo = pageUrl.substr(pageUrl.lastIndexOf("=") + 1);
    setCurrentPage(NewPageNo);
  };

  return (
    <div className={props.type ? "" : "mainInnerView"}>
      {props.type ? "" : <h1>Wallet Points</h1>}
      {props.type === "customer" && (
        <GButton
          variant="linkable"
          children="Add"
          onClick={() => {
            setWalletvisible(true);
          }}
          style={{
            margin: "-40px 0px 10px",
            float: "right",
          }}
        >
          <Add fontSize="large" />
        </GButton>
      )}

      <div className="listPaper">
        {walletData.length > 0 ? (
          <GPagination
            count={walletPaginationData.total}
            from={walletPaginationData.from}
            to={walletPaginationData.to}
            onChangeNextPage={() =>
              handleChangePage(walletPaginationData.next_page_url)
            }
            onChangePrevPage={() =>
              handleChangePage(walletPaginationData.prev_page_url)
            }
            rowsPerPage={walletPaginationData.per_page}
            prevDisabled={walletPaginationData.prev_page_url ? false : true}
            nextDisabled={walletPaginationData.next_page_url ? false : true}
          ></GPagination>
        ) : (
          ""
        )}
        {loading === true ? (
          <TableShimmer></TableShimmer>
        ) : (
          <TableContainer>
            {walletData.length === 0 ? (
              <Placeholder />
            ) : (
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableHeader
                        key={column.id}
                        style={{
                          minWidth:
                            walletData.length > 0 && !column.label
                              ? "30px"
                              : column.minWidth,
                          textAlign: column.align,
                        }}
                      >
                        {column.label}
                      </TableHeader>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {walletData.map((c) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={c.id}>
                        <TableRowData>
                          {c.amount < 0 ? (
                            <img
                              src={withdrawPoints}
                              alt=""
                              style={{ width: "15px" }}
                            />
                          ) : (
                            <img
                              src={earnPoints}
                              alt=""
                              style={{ width: "15px" }}
                            />
                          )}
                        </TableRowData>
                        <TableRowData>{c.amount}</TableRowData>
                        <TableRowData style={{ textAlign: "center" }}>
                          {c.title || "-"}
                        </TableRowData>
                        <TableRowData style={{ textAlign: "center" }}>
                          {c.created}
                        </TableRowData>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        )}
      </div>

      {dialogOpen === true && (
        <GConfirmDialog
          open={dialogOpen}
          title="Delete Customer"
          text="Are you sure you want to delete this customer?"
          handleClose={() => setDialogOpen(false)}
          onConfirmClose={() => {
            setDialogOpen(false);
          }}
        ></GConfirmDialog>
      )}

      <Modal
        isOpen={walletvisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setWalletvisible(false)}
        style={{
          content: {
            width: "400px",
          },
        }}
        contentLabel="Wallet Point Form Modal"
      >
        <WalletForm
          walletvisible={walletvisible}
          setWalletvisible={setWalletvisible}
          onSubmit={() => {
            refreshData(obj);
          }}
          type={props.type}
          id={selectedWalletId}
        />
      </Modal>
    </div>
  );
}
